import { SelectedResource } from "./catalog";

export function findResourceIndex(resources: SelectedResource[], resourceNameToFind: string): number {
  return resources.findIndex(resource => resource.name === resourceNameToFind);
}

export function removeResource(resources: SelectedResource[], removedResourceName: string): SelectedResource[] {
  const removedIndex = findResourceIndex(resources, removedResourceName);

  if (removedIndex !== -1) {
    const leftPart = resources.slice(0, removedIndex);
    const rightPart = resources.slice(removedIndex + 1);

    return [...leftPart, ...rightPart];
  }

  return resources;
}
